import {__} from '@wordpress/i18n';

const VideoThumbnail = ({thumbnails, videoTitle}) => {
    if (!thumbnails) {
        return '';
    }

    const playButtonClassName = `simple-video-preview__play-button ${thumbnails.service}`;

    return (
        <>
            <img
                src={thumbnails.thumbnail}
                alt={__('%%videoTitle%% video preview', 'simple-video-preview').replace('%%videoTitle%%', videoTitle ? `"${videoTitle}" ` : '')}
                className="simple-video-preview__image"
                srcSet={thumbnails.srcset}
                sizes={thumbnails.sizes}
            />
            <span className={playButtonClassName}/>
        </>
);
};

export default VideoThumbnail